var _circle, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFemaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#292374"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8982 25.4904H10.9893V12.3779L23.8982 11.8044V25.4904Z",
    fill: "#7868DB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83501 0 0 7.83502 0 17.5C0 27.165 7.83501 35 17.5 35Z",
    fill: "#36A9E1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0246 30.6396C28.0287 31.6371 26.3213 32.8651 24.1872 33.7042C22.0531 34.5433 19.5777 35.0574 17.5002 35.0574C15.4228 35.0574 12.9474 34.7017 10.9555 33.7748C8.96364 32.8478 7.54087 32.0647 5.97583 30.6396C6.08988 28.4799 7.32135 25.8676 9.207 24.6527C10.1498 24.0452 11.4686 23.6383 12.9301 23.3851C14.4408 23.1378 15.9693 23.0185 17.4998 23.0283C20.5184 23.0283 23.9053 23.4369 25.7935 24.6527C27.6817 25.8684 28.9106 28.4791 29.0246 30.6396Z",
    fill: "#99AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0246 30.6396C28.0287 31.6371 26.3213 32.8651 24.1872 33.7042C22.0531 34.5433 19.5777 35.0574 17.5002 35.0574C15.4228 35.0574 12.9474 34.7017 10.9555 33.7748C8.96364 32.8478 7.54087 32.0647 5.97583 30.6396C6.08988 28.4799 7.32135 25.8676 9.207 24.6527C10.1498 24.0452 11.4686 23.6383 12.9301 23.3851C14.4408 23.1378 15.9693 23.0185 17.4998 23.0283C20.5184 23.0283 23.9053 23.4369 25.7935 24.6527C27.6817 25.8684 28.9106 28.4791 29.0246 30.6396Z",
    fill: "url(#paint0_linear)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.772 22.5907V20.9119H15.226V22.5907C15.2235 22.7672 15.1782 22.9404 15.094 23.0953C15.0097 23.2502 14.8892 23.382 14.7428 23.4794C14.2993 23.7869 14.0171 24.5337 14.0171 25.2338C14.0171 27.023 15.3409 29.9915 17.4986 29.9915C19.734 29.9915 20.9801 27.0273 20.9801 25.2338C20.9801 24.5337 20.698 23.7895 20.2544 23.4794C20.1082 23.3819 19.9878 23.25 19.9037 23.0952C19.8197 22.9403 19.7745 22.7671 19.772 22.5907Z",
    fill: "#DAD4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7714 21.2238V22.799C19.0203 23.2909 18.5819 23.4438 17.8477 23.4438C16.9581 23.4438 16.5019 23.2187 15.3977 22.4345C15.3411 22.3937 15.2854 22.3495 15.2288 22.3113V21.2238C16.2088 21.9035 16.665 22.1057 17.5013 22.1057C18.3377 22.1057 18.7931 21.9043 19.7714 21.2238Z",
    fill: "#DB9172",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4385 15.9155C21.4385 15.1245 21.8786 14.1611 22.421 14.1611C22.9634 14.1611 23.5193 14.314 23.5193 15.105C23.5193 15.4856 23.3503 16.3386 23.1813 16.7132C23.0022 17.1159 22.7015 17.347 22.421 17.347C21.8786 17.347 21.4385 16.7064 21.4385 15.9155Z",
    fill: "#F7BE9F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 7.92767C13.6735 7.92767 12.6301 11.2411 12.6301 15.3352C12.6301 18.048 13.475 19.9808 15.0463 21.0963C16.1539 21.8805 16.6093 22.1048 17.4963 22.1048C18.3876 22.1048 18.843 21.8805 19.9463 21.0963C21.5202 19.9808 22.3634 18.048 22.3634 15.3352C22.3701 11.2436 21.3259 7.92767 17.4997 7.92767Z",
    fill: "#DAD4FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3473 14.9674C22.306 14.6281 22.1965 14.3009 22.0254 14.0056C22.2014 14.2986 22.3113 14.6269 22.3473 14.9674Z",
    fill: "#29235C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4996 7.92767C17.432 7.92767 17.3669 7.92767 17.301 7.93277C20.6744 8.04831 21.6046 11.3167 21.6046 15.3352C21.6046 18.048 20.8273 19.9808 19.3776 21.0963C18.4373 21.8202 18.0056 22.0665 17.301 22.1005C17.3652 22.1005 17.4311 22.1048 17.4996 22.1048C18.3908 22.1048 18.8462 21.8805 19.9496 21.0963C21.5235 19.9808 22.3666 18.048 22.3666 15.3352C22.37 11.2436 21.3258 7.92767 17.4996 7.92767Z",
    fill: "#ECA182",
    fillOpacity: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6302 15.3352C12.6302 11.2436 15.0802 9.36942 15.0802 9.36942C15.0802 9.36942 16.0805 11.01 17.8681 11.5834C20.0402 12.2801 22.3643 13.1365 22.3643 15.3352C22.3643 15.6199 23.8926 13.1373 23.8926 11.8035C23.8926 9.87492 22.5595 5.16394 17.4939 5.16394C11.619 5.16394 10.9836 10.4526 10.9836 12.377C10.9836 13.8323 11.7828 15.1755 12.6598 16.2596C12.6429 15.9622 12.6302 15.6547 12.6302 15.3352Z",
    fill: "#7868DB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0026 13.9716C21.2997 12.8604 19.6827 12.4424 18.0159 12.0584C15.9925 11.5911 15.2119 10.5767 15.2119 10.5767C15.2119 10.5767 12.6724 11.857 12.6656 16.2638C12.6428 15.9656 12.6301 15.6589 12.6301 15.3386C12.6301 11.2479 15.0801 9.37366 15.0801 9.37366C15.0801 9.37366 16.0804 11.0151 17.868 11.5885C19.5256 12.1127 21.2642 12.7346 22.0026 13.9716Z",
    fill: "#DB9172",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 29.0246,
    y1: 29.072,
    x2: 6.82949,
    y2: 29.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D81DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99AAE0",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleIcon);
export default __webpack_public_path__ + "static/media/femaleIcon.a026979c241afbc7a75319c4a75b7350.svg";
export { ForwardRef as ReactComponent };